import { render, staticRenderFns } from "./AccessoriesView.vue?vue&type=template&id=501df157&scoped=true"
import script from "./AccessoriesView.vue?vue&type=script&lang=js"
export * from "./AccessoriesView.vue?vue&type=script&lang=js"
import style0 from "./AccessoriesView.vue?vue&type=style&index=0&id=501df157&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501df157",
  null
  
)

export default component.exports